import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MetaService } from '../../../services/meta.service';

@Component({
  selector: 'app-ux-ui-design',
  templateUrl: './ux-ui-design.component.html',
  styleUrls: ['./ux-ui-design.component.scss']
})
export class UxUiDesignComponent implements OnInit {
  imageUrl!: string;
  contentTitle = 'UX/UI Design - XipeTech';
  contentDescription = 'XipeTech offers expert UX/UI design and development services, creating visually stunning, user-friendly, and responsive interfaces that enhance user experience and drive engagement.';
  contentKeywords = 'ux design, ui design, ux ui development, user interface design, user experience design, responsive web design, app interface design, ux research, wireframing, prototyping, ux ui services';
  pageUrl!: string;
  siteTitle = 'Revolutionary IT Solutions – XipeTech';
  ext = 'png';

  constructor(private metaService: MetaService, private router: Router) { }

  ngOnInit(): void {
    const baseUrl = window.location.origin;
    // Set the page title
    this.metaService.setMetaData({
      title: this.contentTitle,
      description: this.contentDescription,
      keywords: this.contentKeywords,
      siteTitle: this.siteTitle,
      pageUrl: `${baseUrl}${this.router.url}`,
      imageUrl: `${baseUrl}/assets/img/xipetech.png`,
      ext: this.ext
    });
  }
}
